<template>
  <div class="leaveSituation">
    <OATable :data="data" :columns="columns" :filterData="filterData" @search="handleSearch" :loading="loading">
    </OATable>
    <OAModal title="请假详情" :visible="visiabled" @on-cancel="visiabled=false">
      <el-timeline>
        <el-timeline-item v-for="x in detail" :key="x.year" :timestamp="x.year" placement="top">
          <el-tabs type="border-card">
            <el-tab-pane v-for="y in x.data" :key="y.leaveType" :label="`${y.leaveTypeDesc}：共计${y.days}天`">
              <OATableOnly :card="false" :data="y.list" :columns="columns2" size="mini"></OATableOnly>
            </el-tab-pane>
          </el-tabs>
        </el-timeline-item>
      </el-timeline>
    </OAModal>
  </div>
</template>
<script>
  import leaveSituation from "@/services/leaveSituation.js";
  import OAHandle from "@/components/OAHandle/OAHandle";
  import OAModal from "@/components/OAModal/OAModal";

  export default {
    name: "leaveSituation",
    components: {
      OAModal
    },
    data() {
      let that = this;
      return {
        filterData: {
          empId: {
            formType: "a-auto-search",
            value: undefined,
            apiType: "getUnder",
            col: 4,
            placeholder: "姓名工号"
          },
          types: {
            formType: "a-select",
            value: undefined,
            placeholder: "请假类型",
            col: 4,
            api: "leavatype",
            options: [],
            multiple: true,
          },
          companyIds: {
            formType: "a-select",
            value: undefined,
            placeholder: "所属公司",
            col: 4,
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            options: [],
            multiple: true
          },
        },
        columns: [{
          title: "姓名",
          component: {
            name: OAHandle,
            props: {
              textKey: "empName",
              onClick: function (val) {
                that.getDetail(val)
              }
            }
          },
          width: 100
        }, {
          title: "工号",
          key: "number",
          width: 60
        }, {
          title: "公司名称",
          key: "compName",
          width: 200
        }, {
          title: "部门",
          key: "deptName"
        }, {
          title: "请假类型",
          key: "typeDesc",
          width: 100
        }, {
          title: "请假日期",
          key: "startDate",
          formatter: function (row, column, cellValue, index) {
            return row.startDate + ' - ' + row.endDate
          },
          width: 300
        }, {
          title: "请假时长",
          key: "duration",
          formatter: function (row, column, cellValue, index) {
            return row.duration + '天'
          },
          width: 100
        }, {
          title: "请假事由",
          key: "remarks",
          showOverflowTooltip: true,
          formatter: function (row, column, cellValue, index) {
            return cellValue || '-'
          },
        }],
        columns2: [{
          title: "请假日期",
          key: "startDate",
          formatter: function (row, column, cellValue, index) {
            return row.startTime + ' - ' + row.endTime
          },
          width: 300
        }, {
          title: "请假时长",
          key: "duration",
          formatter: function (row, column, cellValue, index) {
            return cellValue + '天'
          },
        }, {
          title: "请假事由",
          key: "remarks",
          showOverflowTooltip: true,
          formatter: function (row, column, cellValue, index) {
            return cellValue || '-'
          },
        }],
        data: [],
        loading: false,
        visiabled: false,
        detail: []
      };
    },
    mounted() {},
    methods: {
      async handleSearch(val) {
        this.loading = true;
        let res = await leaveSituation.getapprovallist(val);
        this.data = res.data.data;
        this.loading = false;
      },
      async getDetail(scope) {
        let res = await leaveSituation.getapprovaldetail({
          applyId: scope.row.empId
        })
        this.visiabled = true
        this.detail = []
        let data = res.data.data.data
        if (data) {
          Object.keys(data).forEach(item => {
            if (data[item] && data[item].length) {
              this.detail.push({
                "year": item,
                "data": data[item]
              })
            }
          })
          this.detail.sort((a, b) => b.year - a.year)
        }
      }
    }
  }

</script>
<style lang="scss">
  .leaveSituation {
    .OATable {
      .OAHeader {
        ul {
          height: 25px;
          margin-bottom: 20px;

          li {
            float: left;

            &:last-child {
              margin-left: 15px;
            }

            a {
              padding: 10px 15px;
              background: #fff;
              color: #8391a5;
              font-size: 14px;
              cursor: pointer;

              &.active {
                border-bottom: 2px solid #20a0ff;
                color: #20a0ff;
              }

              &:hover {
                color: #20a0ff;
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/self/leaveSituation.vue